// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__clVNH","primary":"style_primary__c9048"};